import { HTTP } from '@util/http-p'

class LoginModel extends HTTP {
    checkLogin(data) {
        return this.request({
            url: 'apiadmin/index/login',
            data: data
        })
    }
}

export { LoginModel }